module.exports = __webpack_public_path__ + "assets/img/4545997e809fe76a39677f21e7d0ef9e.png";